module.exports = __webpack_public_path__ + "img/nicaragua.f72c67c0.svg";